import type { SVGProps } from "react";

const VehicleIcon = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M23.46 8.958h-2.69l-.747-1.841C19.255 5.223 17.422 4 15.353 4H9.646C7.578 4 5.744 5.223 4.976 7.117l-.748 1.841H1.54a.533.533 0 0 0-.523.66l.27 1.063c.06.236.275.402.523.402h.901a2.797 2.797 0 0 0-.991 2.125v2.125c0 .714.276 1.358.718 1.857v2.393c0 .783.644 1.417 1.438 1.417h1.437c.794 0 1.438-.634 1.438-1.417v-1.416h11.5v1.416c0 .783.644 1.417 1.437 1.417h1.438c.794 0 1.437-.634 1.437-1.417V17.19a2.786 2.786 0 0 0 .72-1.857v-2.125c0-.85-.39-1.605-.992-2.125h.901a.537.537 0 0 0 .523-.402l.27-1.063a.533.533 0 0 0-.524-.66ZM7.645 8.17a2.156 2.156 0 0 1 2.002-1.336h5.705c.882 0 1.675.53 2.003 1.336l.895 2.206H6.75l.895-2.206Zm-2.333 7.155c-.862 0-1.437-.564-1.437-1.412 0-.847.575-1.412 1.437-1.412.863 0 2.157 1.271 2.157 2.118 0 .848-1.294.707-2.157.707Zm14.375 0c-.862 0-2.156.142-2.156-.706 0-.847 1.294-2.118 2.156-2.118.863 0 1.438.565 1.438 1.412 0 .848-.575 1.412-1.438 1.412Z"
    />
    <path
      fill="#FBFBFB"
      d="M7.638 8.22A2.157 2.157 0 0 1 9.64 6.884h5.705c.882 0 1.675.53 2.002 1.336l.896 2.206h-11.5l.895-2.206Zm-2.333 7.156c-.862 0-1.437-.565-1.437-1.413 0-.847.575-1.412 1.437-1.412.863 0 2.156 1.271 2.156 2.118 0 .848-1.293.707-2.156.707Zm14.375 0c-.862 0-2.156.14-2.156-.707s1.294-2.118 2.156-2.118c.863 0 1.438.565 1.438 1.412 0 .848-.575 1.413-1.438 1.413Z"
    />
  </svg>
);
export default VehicleIcon;
